// openaiHelper.ts

import OpenAI from "openai";

const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

const openai = new OpenAI({
  apiKey: OPENAI_API_KEY || " ",
  dangerouslyAllowBrowser: true,
});

export default openai;
